import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_warehouse_layout_node_container_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid: fromDatatype.GuidDataFieldInterface;
    container_hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    layout_node_space_name: fromDatatype.VarcharDatatypeInterface;
    layout_node_space_machine_code: fromDatatype.VarcharDatatypeInterface;
    container_name: fromDatatype.VarcharDatatypeInterface;
    container_machine_code: fromDatatype.VarcharDatatypeInterface;   
}

export class bl_wms_warehouse_layout_node_container_link_RowClass implements bl_wms_warehouse_layout_node_container_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid: fromDatatype.GuidDataFieldInterface;
    container_hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    layout_node_space_name: fromDatatype.VarcharDatatypeInterface;
    layout_node_space_machine_code: fromDatatype.VarcharDatatypeInterface;
    container_name: fromDatatype.VarcharDatatypeInterface;
    container_machine_code: fromDatatype.VarcharDatatypeInterface;
}